import VueMonthlyPicker from 'vue-monthly-picker'
import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import { required } from "vuelidate/lib/validators";
import Loading from 'vue-loading-overlay';
import CONFIG from "@/assets/js/config.js";
import axios from "axios";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
  name: "shiftAssign",
  components: {
    MainLayout,
    Select2Multiple,
    VueMonthlyPicker,
    AdvancedLaravelVuePaginate,
    Loading,
    flatPickr,
  },

  data() {
    return {
      selectedStatus: 'pattern',
      showPatternDropdown: true,
      showDefaultShifts: false,
      defaultShifts: [],
      searchData: {
        name: "",
      },
      patternOptions: [],
      activeTeacherData: [],
      academicYearArr: [],
      noDataMsg: CONFIG.NO_DATA_FOUND,
      isLoading: false,
      from_date: '',
      to_date: '',
      selectedShifts: [],
      selectedTeachers: [],
      checkAll: false,
      disabled: false,
      allTeacherData: [],
      pattern: null,
      errors: {
        from_date: '',
        to_date: '',
        pattern: '',
        selectedShifts: '',
        selectedTeachers: ''
      },
      dateError: "",
      includeWeekend: false,
    };
  },

  validations: {
    searchData: {
      name: {
        required,
      },
    },
  },

  computed: {
    isAllSelected: {
      get() {
        return this.activeTeacherData.length > 0 && this.selectedTeachers.length === this.activeTeacherData.length;
      },

      set(value) {
        this.selectedTeachers = value ? this.activeTeacherData.map(t => t.id) : [];
      }
    }
  },

  methods: {
    searchTeacher() {
      const query = this.searchData.name.trim();

      if (!query) {
        this.allTeacherData = [...this.activeTeacherData];
        return;
      }

      this.activeTeacherData = this.activeTeacherData.filter(teacher => {
        return (
          teacher.name.toLowerCase().includes(query.toLowerCase()) ||
          teacher.teacher_no.toString().includes(query)
        );
      });
    },

    onStatusChange() {
      if (this.selectedStatus === 'pattern') {
        this.showPatternDropdown = true;
        this.showDefaultShifts = false;
        this.includeWeekend = false;
      } else if (this.selectedStatus === 'default') {
        this.showPatternDropdown = false;
        this.showDefaultShifts = true;
        this.getShiftData();
      }
    },

    getActiveTeacherList() {
      this.isLoading = true;
      axios.get("/teacher/active-list")
      .then((response) => {
        this.activeTeacherData = response.data?.data || response.data || [];
        this.allTeacherData = [...this.activeTeacherData];
      })
      .catch((error) => {
        if (error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        this.isLoading = false;
      });
    },

    async getShiftData() {
      try {
        const res = await axios.get('shift/assign');
        this.defaultShifts = res.data.default;
        this.patternOptions = res.data.patterns;
      } catch (err) {
        console.error(err);
      }
    },

    async selectAll() {
      if (this.checkAll) {
        this.selectedTeachers = this.activeTeacherData.map(t => t.id);
      } else {
        this.selectedTeachers = [];
      }
    },

    async submit() {
      this.errors = {
        from_date: '',
        to_date: '',
        pattern: '',
      };

      const payload = {
        assign_type: this.selectedStatus,
        teacher_ids: this.selectedTeachers,
        from_date: this.from_date,
        to_date: this.to_date,
        campus_id: this.$store.state.user.campus_id,
        pattern_id: this.selectedStatus === 'pattern' ? this.pattern : undefined,
        shift_ids: this.selectedStatus === 'default' ? this.selectedShifts : undefined,
        include_weekend: this.selectedStatus === 'default' ? this.includeWeekend : false,
        login_id: Number(this.$store.state.user.id),
      };

      try {
        this.isLoading = true;
        const res = await axios.post('/shift/assign', payload, {
          headers: {
            'Content-Type': 'application/json'
          }
        });

        if (res.data.success) {
          this.$notification.success(res.data.message, { timer: 3, position: "bottomCenter" });
          this.$router.push({
            path: "/attendanceTeacher/list"
          });
        } else {
          this.$notification.error(res.data.message, { timer: 3, position: "bottomCenter" });
        }
      } catch (err) {
        if (err.response && err.response.status === 422) {
          const validationErrors = err.response.data.errors;

          if (validationErrors.from_date) this.errors.from_date = validationErrors.from_date[0];
          if (validationErrors.to_date) this.errors.to_date = validationErrors.to_date[0];
          if (validationErrors.pattern_id) this.errors.pattern = validationErrors.pattern_id[0];
          if (this.selectedStatus === 'default' && validationErrors.shift_ids) {
            this.$notification.error(validationErrors.shift_ids[0], { timer: 3, position: "bottomCenter" });
          } else if (validationErrors.teacher_ids) {
            this.$notification.error(validationErrors.teacher_ids[0], { timer: 3, position: "bottomCenter" });
          } else if (validationErrors.shift_date_empty) {
            this.$notification.error(validationErrors.shift_date_empty[0], { timer: 3, position: "bottomCenter" });
          }
          Object.keys(validationErrors).forEach(key => {
            if (key.startsWith('shift_overlap.')) {
              this.$set(this.errors, key, validationErrors[key][0]);
            }
          });
          if (validationErrors.holiday_exists) {
            const firstKey = Object.keys(validationErrors)[0];
            const firstMessage = validationErrors[firstKey][0];
            this.$notification.error(firstMessage, {
              timer: 3,
              position: "bottomCenter"
            });
          }
          return;
        } else {
          console.error(err);
          this.$notification.error('Something went wrong', { timer: 3, position: "bottomCenter" });
        }
      } finally {
        this.isLoading = false;
      }
    },

    resetForm() {
      this.selectedTeachers = [];
      this.selectedShifts = [];
      this.pattern = null;
      this.from_date = '';
      this.to_date = '';
      this.checkAll = false;
    },

    formatTime(time) {
      if (!time) return "";
      const [hours, minutes] = time.split(':');
      let h = parseInt(hours);
      const m = minutes;
      const ampm = h >= 12 ? 'PM' : 'AM';
      h = h % 12;
      h = h ? h : 12;
      return `${h}:${m} ${ampm}`;
    },
  },

  watch: {
    "searchData.name"(newVal) {
      const query = newVal.trim().toLowerCase();
      if (!query) {
        this.activeTeacherData = [...this.allTeacherData];
      } else {
        this.activeTeacherData = this.allTeacherData.filter(teacher =>
          teacher.name.toLowerCase().includes(query) ||
          teacher.teacher_no.toString().includes(query)
        );
      }
    },

    selectedTeachers(newVal) {
      this.checkAll = this.activeTeacherData.length > 0 && newVal.length === this.activeTeacherData.length;
    }
  },

  mounted() {
    this.isLoading = true;
    Promise.all([this.getShiftData(), this.getActiveTeacherList()])
      .finally(() => {
        this.isLoading = false;
      });
  },
};
